import * as React from "react";
import { Outlet } from "react-router-dom";

export const PageFrame = (): React.JSX.Element => {
  return (
    <main>
      <div>
        <span>Nurse</span>
        <span>Test</span>
      </div>
      <Outlet />
    </main>
  );
};
